module.exports = __webpack_public_path__ + "img/ic_z@2x.67008ace.png";